import Vue from 'vue';
import Router from 'vue-router';
import { appContext } from './composition-root';
import { buildRoutes } from './route-registry';

Vue.use(Router);

const { tenant, access, customer } = appContext;

// Las rutas salen de `tenant.routes` (ver `route-registry.ts`); cada una lleva su acceso en `meta.access`.
export const router = new Router({
    mode: 'history',
    routes: buildRoutes(tenant.routes)
});

// Guard global: título del documento + acceso de la ruta destino (`AccessCoordinator` elige la estrategia)
router.beforeEach((to, from, next) => {
    document.title = tenant.branding.documentTitle;
    access.guard(to, from, next);
});

// Tras cada navegación confirmada, la aseguradora se vuelve a resolver según el acceso de la ruta (el `HomePage` se
// reutiliza entre rutas de sesión y por token): `/me/` con el token nuevo o refresco del `userInfo` de la sesión.
router.afterEach(() => {
    customer.refresh();
});

export default router;
